<script setup>
const props = defineProps({
    button: {
        type: [Object, Boolean],
        required: false,
        default: false,
    },
    label: {
        type: String,
        required: false,
        default: '',
    },
    link: {
        type: [String, Boolean],
        required: false,
        default: false,
    },
    icon: {
        type: [String, Boolean],
        required: false,
        default: false,
    },
    title: {
        type: String,
        required: false,
        default: '',
    },
    target: {
        type: Boolean,
        required: false,
        default: false
    },
    color: {
        type: String,
        required: false,
        default: 'var(--orange)'
    },
    hoverColor: {
        type: String,
        required: false,
        default: 'white'
    },
    filledIn: {
        type: Boolean,
        required: false,
        default: false,
    },
    outline: {
        type: Boolean,
        required: false,
        default: false,
    },
    magenta: {
        type: Boolean,
        required: false,
        default: false,
    },
});

const dataStyle = computed(() => {
    if (props.filledIn) return 'filled-in';
    if (props.outline) return 'outline';
    if (props.magenta) return 'magenta';
    return 'default'
})
</script>

<template>
    <MessButton :data-style="`${dataStyle}`"
        :style="`--color: ${color}; --hover-color: ${hoverColor};`"
        :targetOverride="target"
        :button="button" :label="label" :link="link"
        :icon="icon" :title="title" />
</template>

<style>
.mess-button {
    --hover-color: var(--hover-color);
    --hover-background-color: var(--orange);
    --background-color: transparent;
    --border-width: 1px;

    text-transform: uppercase;
    color: var(--color);
    text-align: center;
    font-size: 0.8125rem;
    font-weight: 400;
    letter-spacing: 0.065rem;
    padding: 0.9375rem;
    display: inline-block;
    border: var(--border-width) solid;
    border-radius: var(--radius);
    position: relative;
    transition: 250ms ease;
}

.mess-button span {
    position: relative;
    z-index: 1;
}

.mess-button:hover,
.mess-button:focus,
.mess-button:active {
    color: var(--hover-color);
    background-color: var(--hover-background-color);
}

.mess-button[data-style='filled-in'] {
    color: var(--hover-color);
    background-color: var(--hover-background-color);
    border-color: var(--hover-background-color);
}

.mess-button[data-style='filled-in']:hover,
.mess-button[data-style='filled-in']:focus,
.mess-button[data-style='filled-in']:active {
    color: var(--color);
    border-color: var(--color);
    background-color: var(--background-color);
}

.mess-button[data-style='outline'] {
    color: var(--hover-color);
    background-color: transparent;
    border-color: var(--hover-color);
}

.mess-button[data-style='outline']:hover,
.mess-button[data-style='outline']:focus,
.mess-button[data-style='outline']:active {
    color: var(--color);
    border-color: transparent;
    background-color: var(--hover-color);
}

.mess-button[data-style='magenta'] {
    color: white;
    background-color: transparent;
    border-color: white;
}

.mess-button[data-style='magenta']:hover,
.mess-button[data-style='magenta']:focus,
.mess-button[data-style='magenta']:active {
    color: var(--magenta);
    border-color: white;
    background-color: white;
}
</style>
